module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-ad-foot",
    attrs: {
      "id": "c-ad-foot"
    }
  }, [_c('ins', {
    staticClass: "adsbygoogle",
    staticStyle: {
      "display": "inline-block",
      "width": "970px",
      "height": "90px"
    },
    attrs: {
      "data-ad-client": "ca-pub-1949121304889987",
      "data-ad-slot": "7586846034"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0067aedc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/component/ad-foot.vue
// module id = 56
// module chunks = 0